// extracted by mini-css-extract-plugin
export default {"footer":"footer__1Hfuh","button":"button__1puc_","contact":"contact__3BnUR","dropdown":"dropdown__3zuQz","leave":"leave__1tUks","header":"header__3bx0B"};